// components/Almacenes.jsx
import React, { useState, useEffect } from "react";
import api from "../services/api";
import "./Almacenes.css";

const Almacenes = () => {
  const [almacenes, setAlmacenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [modalAbierto, setModalAbierto] = useState(false);
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState(null);
  const [estadisticas, setEstadisticas] = useState(null);
  
  const [formData, setFormData] = useState({
    nombre: "",
    tipo: "secundario",
    codigo: "",
    ubicacion: "",
    responsable: "",
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [almacenesRes, estadisticasRes] = await Promise.all([
        api.get("/almacenes"),
        api.get("/almacenes/estadisticas"),
      ]);
      setAlmacenes(almacenesRes.data);
      setEstadisticas(estadisticasRes.data);
    } catch (error) {
      console.error("Error al cargar almacenes:", error);
      mostrarMensaje("Error al cargar datos", "error");
    } finally {
      setLoading(false);
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
  };

  const abrirModal = (almacen = null) => {
    if (almacen) {
      setAlmacenSeleccionado(almacen);
      setFormData({
        nombre: almacen.nombre,
        tipo: almacen.tipo,
        codigo: almacen.codigo,
        ubicacion: almacen.ubicacion || "",
        responsable: almacen.responsable || "",
      });
    } else {
      setAlmacenSeleccionado(null);
      setFormData({
        nombre: "",
        tipo: "secundario",
        codigo: "",
        ubicacion: "",
        responsable: "",
      });
    }
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setAlmacenSeleccionado(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (almacenSeleccionado) {
        // Actualizar
        await api.put(`/almacenes/${almacenSeleccionado.id}`, formData);
        mostrarMensaje("✅ Almacén actualizado correctamente", "success");
      } else {
        // Crear
        await api.post("/almacenes", formData);
        mostrarMensaje("✅ Almacén creado correctamente", "success");
      }
      cerrarModal();
      cargarDatos();
    } catch (error) {
      console.error("Error al guardar almacén:", error);
      mostrarMensaje(
        error.response?.data?.error || "Error al guardar almacén",
        "error"
      );
    }
  };

  const verStock = (almacenId) => {
    window.location.href = `/almacenes/${almacenId}/stock`;
  };

  if (loading) {
    return <div className="loading">Cargando almacenes...</div>;
  }

  return (
    <div className="almacenes-container">
      <div className="header">
        <h1>📦 Gestión de Almacenes</h1>
        <button className="btn-primary" onClick={() => abrirModal()}>
          ➕ Nuevo Almacén
        </button>
      </div>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>{mensaje.texto}</div>
      )}

      {/* Estadísticas */}
      {estadisticas && (
        <div className="estadisticas-grid">
          <div className="stat-card">
            <div className="stat-icon">📦</div>
            <div className="stat-info">
              <span className="stat-label">Total Almacenes</span>
              <span className="stat-value">{estadisticas.total_almacenes}</span>
            </div>
          </div>
          {estadisticas.estadisticas.map((est, index) => (
            <div className="stat-card" key={index}>
              <div className="stat-icon">
                {est.almacen_tipo === "principal" ? "🏢" : "📍"}
              </div>
              <div className="stat-info">
                <span className="stat-label">{est.almacen_nombre}</span>
                <span className="stat-value">{est.total_materiales} materiales</span>
                <span className="stat-subtitle">
                  RD$ {est.valor_total.toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Tabla de Almacenes */}
      <div className="card">
        <table className="tabla-almacenes">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Tipo</th>
              <th>Ubicación</th>
              <th>Responsable</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {almacenes.map((almacen) => (
              <tr key={almacen.id}>
                <td>
                  <strong>{almacen.codigo}</strong>
                </td>
                <td>{almacen.nombre}</td>
                <td>
                  <span
                    className={`badge ${
                      almacen.tipo === "principal" ? "badge-primary" : "badge-secondary"
                    }`}
                  >
                    {almacen.tipo === "principal" ? "🏢 Principal" : "📍 Secundario"}
                  </span>
                </td>
                <td>{almacen.ubicacion || "-"}</td>
                <td>{almacen.responsable || "-"}</td>
                <td>
                  <span
                    className={`badge ${
                      almacen.activo ? "badge-success" : "badge-inactive"
                    }`}
                  >
                    {almacen.activo ? "✅ Activo" : "⛔ Inactivo"}
                  </span>
                </td>
                <td className="acciones">
                  <button
                    className="btn-mini btn-info"
                    onClick={() => verStock(almacen.id)}
                    title="Ver Stock"
                  >
                    📊
                  </button>
                  {!almacen.es_default && (
                    <button
                      className="btn-mini btn-edit"
                      onClick={() => abrirModal(almacen)}
                      title="Editar"
                    >
                      ✏️
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {almacenes.length === 0 && (
          <div className="empty-state">
            <p>No hay almacenes registrados</p>
          </div>
        )}
      </div>

      {/* Modal Crear/Editar */}
      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{almacenSeleccionado ? "Editar Almacén" : "Nuevo Almacén"}</h2>
              <button className="btn-close" onClick={cerrarModal}>
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Código <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.codigo}
                    onChange={(e) =>
                      setFormData({ ...formData, codigo: e.target.value.toUpperCase() })
                    }
                    placeholder="ALM-001"
                    disabled={!!almacenSeleccionado}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    Nombre <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.nombre}
                    onChange={(e) =>
                      setFormData({ ...formData, nombre: e.target.value })
                    }
                    placeholder="Almacén Zona Industrial"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Tipo</label>
                  <select
                    value={formData.tipo}
                    onChange={(e) =>
                      setFormData({ ...formData, tipo: e.target.value })
                    }
                    disabled={!!almacenSeleccionado}
                  >
                    <option value="secundario">📍 Secundario</option>
                    <option value="principal">🏢 Principal</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Responsable</label>
                  <input
                    type="text"
                    value={formData.responsable}
                    onChange={(e) =>
                      setFormData({ ...formData, responsable: e.target.value })
                    }
                    placeholder="Nombre del responsable"
                  />
                </div>

                <div className="form-group full-width">
                  <label>Ubicación</label>
                  <textarea
                    value={formData.ubicacion}
                    onChange={(e) =>
                      setFormData({ ...formData, ubicacion: e.target.value })
                    }
                    placeholder="Dirección física del almacén"
                    rows="3"
                  />
                </div>
              </div>

              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {almacenSeleccionado ? "Actualizar" : "Crear"} Almacén
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Almacenes;